import React, { type FunctionComponent } from 'react'
import { type FormikProps } from 'formik'
import { type ReportFilterDefinitionsInterface } from '__codegen__/api'
import { type GeneratedReportsAddFormValues } from 'legacy/sections/generated-reports/components/add/components/form/utils/generatedReportsAddForm.types'
import { FormField } from 'legacy/dash-components/forms/form-field/FormField'
import {
  generatedReportsFilterFormKeyMapping,
  generatedReportsFilterLabelMapping,
} from 'legacy/sections/generated-reports/components/add/components/form/filters/utils/generatedReportsAddFormFilters.utils'
import { GeneratedReportsAddFormFilter } from 'legacy/sections/generated-reports/components/add/components/form/filters/components/GeneratedReportsAddFormFilter'

interface Props
  extends Pick<GeneratedReportsAddFormValues, 'reportType'>,
    FormikProps<GeneratedReportsAddFormValues> {
  reportFilters: ReportFilterDefinitionsInterface[]
}

export const GeneratedReportsAddFormFilters: FunctionComponent<Props> = ({
  reportFilters,
  reportType,
  ...rest
}) => {
  const { touched, errors } = rest

  return (
    <fieldset data-testid="generated-reports-add-form-filters">
      {reportFilters.map(filter => {
        const fieldName = generatedReportsFilterFormKeyMapping(filter)
        const fieldLabel = generatedReportsFilterLabelMapping(filter)
        const isTouched = touched[fieldName]
        const error = errors[fieldName]

        return (
          <FormField
            key={filter.filterType}
            name={fieldName}
            intlId={fieldLabel}
            error={isTouched && error ? error.toString() : undefined}
          >
            <GeneratedReportsAddFormFilter filter={filter} formikProps={rest} />
          </FormField>
        )
      })}
    </fieldset>
  )
}
